// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circular__border[data-v-65219643]{outline:6px solid #fff}.v-card__actions[data-v-65219643]{background-color:transparent}.v-card[data-v-65219643]{box-shadow:0 2px 29px rgba(143,189,204,.29)}.v-card[data-v-65219643]:after{content:\"\";position:absolute;visibility:visible;bottom:-40px;left:0;border-right:40px solid transparent;border-top:45px solid #fff;clear:both}.rev__title__underline[data-v-65219643]{border-bottom:6px solid #165fd8;width:15%;padding-top:16px;margin-left:22%}", ""]);
// Exports
module.exports = exports;
